module.exports = "/images/freelance-writers-guild-ph.png?e168ed7c0cbabe12db0af2425102f92a";